export default "__VITE_ASSET__dde145bd__"